import { Component, OnInit } from "@angular/core";
import { SystemReportsService } from "../system.reports.service";
import { AuthenticationService } from "src/app/services/authentication.service";
import { IUser } from "src/app/interface/user";
import Swal from "sweetalert2";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { SystemReportsStyle } from "../system.reports.style";
import { AssetAttributesService } from "src/app/services/asset-attributes.service";
import { CustomTranslatePipe } from "../../shared/custom-translate.pipe";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
@Component({
    selector: "app-sms-replaceyearasset",
    templateUrl: "./replaceYearAssetClass.component.html",
    styleUrls: ["../system.reports.component.scss"],
    standalone: true,
    imports: [TranslateModule, CustomTranslatePipe]
})
export class replaceYearAssetClassComponent implements OnInit {
  private currentUser: IUser;
  private tableAliases: any;
  constructor(public systemReportsService: SystemReportsService, private authenticationService: AuthenticationService, private translateService: TranslateService, private reportStyle: SystemReportsStyle,private assetAttributesService: AssetAttributesService) {
    this.currentUser = this.authenticationService.currentUserValue;
  }
  ngOnInit() {
    console.log("Component Init");
  }

  openReports() {
    try {
      this.systemReportsService.getProjectReplaceAssetDetails().subscribe(
        (res) => {
          this.assetAttributesService.getTableAlias().subscribe((tblresults: any) => {
            this.tableAliases = tblresults.features;
            this.JSONToPDFConvertor(res, true);
          });
        },
        (err) => {
          Swal.fire("Please contact administrator. API is throwing an error");
        }
      );
    } catch (error) {
      console.error(error);
    }
  }

  JSONToPDFConvertor(res, ShowLabel) {
    try {
      let JSONData = [];

      if (res.tblReplaceAssets.length > 0) {
        JSONData = res.tblReplaceAssets;
      } else {
        Swal.fire(this.translateService.instant("Systemreports.alertactivitybyreason.nodatafound"));
        return;
      }

      // If JSONData is not an object then JSON.parse will parse the JSON string in an Object
      const arrData = typeof JSONData !== "object" ? JSON.parse(JSONData) : JSONData;
      const tableheader = [];
      const tablebody = [];
      let tablerow = [];
      const currentReportStyle = this.reportStyle.getReportStyle();
      const currentLayoutStyle = this.reportStyle.getReportLayout();
      const currentFooter = this.reportStyle.getReportFooter();
      const currentYear = new Date().getFullYear();

      console.log(arrData);

      // This condition will generate the Label/Header
      if (ShowLabel) {
        // This loop will extract the label from 1st index of on array
        tableheader.push(
          { text: this.translateService.instant("Systemreports.headerreplaceyrassetclass.assetsubtype"), style: "tableHeader" },
          { text: (currentYear - 1).toString(), style: "tableHeader" },
          { text: currentYear.toString(), style: "tableHeader" },
          { text: (currentYear + 1).toString(), style: "tableHeader" },
          { text: (currentYear + 2).toString(), style: "tableHeader" },
          { text: (currentYear + 3).toString(), style: "tableHeader" }
        );
        tablebody.push(tableheader);
      }

      let assetClass = [];
      arrData.forEach((data) => {
        if (data.assetName !== "") {
          assetClass.push(data.assetName);
        }
      });

      const distinct = (value: any, index: any, self: any) => {
        return self.indexOf(value) === index;
      };

      assetClass = assetClass.filter(distinct);

      // 1st loop is to extract each row
      for (let j = 0; j < assetClass.length; j++) {
        const total = [];
        const arr = arrData.filter((obj) => obj.assetName.includes(assetClass[j]));
        const tableAlias = this.tableAliases.map(a => a['attributes']).filter((lyr) => lyr.Name === assetClass[j])[0].Alias;

        if (j === 0) {
          tablebody.push([
            {
              colSpan: 6,
              text: tableAlias,
              style: "rowGroupHeader"
            },
            "",
            "",
            "",
            "",
            ""
          ]);
        } else {
          tablebody.push([
            {
              colSpan: 6,
              text: tableAlias,
              style: "rowGroupHeader",
              pageBreak: "before"
            },
            "",
            "",
            "",
            "",
            ""
          ]);
        }

        const IndexVal = ["assetSubtype"];
        IndexVal.push((currentYear - 1).toString());
        IndexVal.push(currentYear.toString());
        IndexVal.push((currentYear + 1).toString());
        IndexVal.push((currentYear + 2).toString());
        IndexVal.push((currentYear + 3).toString());
        let t1 = 0;
        let t2 = 0;
        let t3 = 0;
        let t4 = 0;
        let t5 = 0;

        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < arr.length; i++) {
          tablerow = [];

          // 2nd loop will extract each column and push in the table row
          if (arr[i].assetSubtype !== "") {
            if (arr[i].assetSubtype !== null) {
              IndexVal.forEach((index) => {
                switch (index) {
                  case "assetSubtype":
                    if (arr[i].assetSubtype === "0") {
                      tablerow.push({ text: "[R] Regulatory (Non Parking)", style: "tableContent" });
                    } else if (arr[i].assetSubtype === "1") {
                      tablerow.push({ text: "[R] Regulatory (Parking)", style: "tableContent" });
                    } else if (arr[i].assetSubtype === "2") {
                      tablerow.push({ text: "[W/O] Warning / Object Marker", style: "tableContent" });
                    } else if (arr[i].assetSubtype === "3") {
                      tablerow.push({ text: "[D/M] Guide", style: "tableContent" });
                    } else if (arr[i].assetSubtype === "4") {
                      tablerow.push({ text: "[S] School", style: "tableContent" });
                    } else if (arr[i].assetSubtype === "5") {
                      tablerow.push({ text: "[R] Recreation", style: "tableContent" });
                    } else if (arr[i].assetSubtype === "6") {
                      tablerow.push({ text: "[D/I] Information", style: "tableContent" });
                    } else if (arr[i].assetSubtype === "7") {
                      tablerow.push({ text: "[D/M] General Services", style: "tableContent" });
                    } else {
                      tablerow.push({ text: arr[i][index], style: "tableContent" });
                    }

                    break;
                  case (currentYear - 1).toString():
                    t1 = t1 + arr[i][index];
                    tablerow.push({ text: arr[i][index], style: "tableContent" });
                    break;
                  case currentYear.toString():
                    t2 = t2 + arr[i][index];
                    tablerow.push({ text: arr[i][index], style: "tableContent" });
                    break;
                  case (currentYear + 1).toString():
                    t3 = t3 + arr[i][index];
                    tablerow.push({ text: arr[i][index], style: "tableContent" });
                    break;
                  case (currentYear + 2).toString():
                    t4 = t4 + arr[i][index];
                    tablerow.push({ text: arr[i][index], style: "tableContent" });
                    break;
                  case (currentYear + 3).toString():
                    t5 = t5 + arr[i][index];
                    tablerow.push({ text: arr[i][index], style: "tableContent" });
                    break;
                }
              });
              // add a line break after each row
              tablebody.push(tablerow);
            }
          }
        }

        total.push(
          { text: this.translateService.instant("Systemreports.headerreplaceyrassetclass.total"), style: "tableHeader" },
          { text: t1, style: "tableHeader" },
          { text: t2, style: "tableHeader" },
          { text: t3, style: "tableHeader" },
          { text: t4, style: "tableHeader" },
          { text: t5, style: "tableHeader" }
        );
        tablebody.push(total);
      }

      const dd = {
        pageSize: "A4",
        pageOrientation: "portrait",
        footer: currentFooter,
        content: [
          {
            text: this.translateService.instant("Systemreports.headerreplaceyrassetclass.projectedreplaceyr"),
            style: "header"
          },
          {
            style: "tableExample",
            table: {
              widths: [140, 60, 60, 60, 60, 60, 60, 60],
              heights: 20,
              headerRows: 1,
              body: tablebody
            },
            pageOrientation: "landscape",
            layout: currentLayoutStyle
          }
        ],
        styles: currentReportStyle
      };
      pdfMake.createPdf(dd).open();
    } catch (error) {
      console.error(error);
    }
  }
}
